// import { route } from "../../../../spice-server/routes/experts";
import { AppRoutes } from "../routes/app-routes";

export const pages = [
    {
        value: 'About',
        route: ''
    },
    {
        value: 'Become an Expert',
        route: ''
    },
    {
        value: 'Become a Trainer',
        route: ''
    },
    {
        value: 'Request support',
        route: ''
    },
    {
        value: 'Partnerships',
        route: AppRoutes.Partnerships
    }
];